import { constantRouterMap, asyncRouterMap } from '@/router';

const permission = {
  state: {
    routes: [],
  },

  mutations: {
    SET_ROUTES: (state, routes) => {
      state.routes = constantRouterMap.concat(routes);
    }
  },

  actions: {
    //获取路由表
    generateRoutes({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        let accessedRoutes;
        // console.log('传过来的用户信息===>', userInfo)
        accessedRoutes = asyncRouterMap || [];
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes);
      })
    },
  }

}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js